import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import logo from "../../assests/oba_logo_nbg.png";

export default function HeaderComponent() {
  return (
    <header
      className="navbar navbar-expand-lg bg-white shadow-sm sticky-top py-2"
      style={{
        zIndex: 1000,
        // borderTop: "10px solid #3C0008",
        // boxSizing: "border-box",
      }}
    >
      <div className="container">
        {/* Logo */}
        <Link to="/" className="navbar-brand">
          <img
            src={logo}
            alt="OBA Logo"
            style={{ height: "100px" }}
            className="d-inline-block align-top"
          />
        </Link>

        {/* Mobile Toggle */}
        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#headerNav"
          aria-controls="headerNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation */}
        <div className="collapse navbar-collapse mt-3 mt-lg-0" id="headerNav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center flex-wrap">
            <li className="nav-item">
              <Link
                className="nav-link vcg-nav-hover text-dark fw-semibold px-3 py-2"
                to="/"
              >
                Home
              </Link>
            </li>

            <li
              className="nav-item dropdown"
              onMouseEnter={(e) => {
                e.currentTarget
                  .querySelector(".dropdown-menu")
                  .classList.add("show");
              }}
              onMouseLeave={(e) => {
                e.currentTarget
                  .querySelector(".dropdown-menu")
                  .classList.remove("show");
              }}
            >
              <Link
                className="nav-link dropdown-toggle vcg-nav-hover text-dark fw-semibold px-3 py-2"
                to="#"
                role="button"
                data-bs-toggle="dropdown"
              >
                Old Boys' Association
              </Link>

              <ul className="dropdown-menu shadow-sm border-0">
                <li>
                  <Link
                    className="dropdown-item vcg-nav-hover py-2 fw-semibold "
                    to="/old-boys-association"
                  >
                    Overview
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item vcg-nav-hover py-2 fw-semibold "
                    to="/old-boys-association/history"
                  >
                    History
                  </Link>
                </li>
              </ul>
            </li>

            <li className="nav-item">
              <Link
                className="nav-link vcg-nav-hover text-dark fw-semibold px-3 py-2"
                to="/news-feed"
              >
                News Feed
              </Link>
            </li>

            {/* <li className="nav-item">
              <Link
                className="nav-link vcg-nav-hover text-dark fw-semibold px-3 py-2"
                to="/events"
              >
                Events
              </Link>
            </li> */}

            {/* Membership Dropdown */}
            <li
              className="nav-item dropdown"
              onMouseEnter={(e) => {
                e.currentTarget
                  .querySelector(".dropdown-menu")
                  .classList.add("show");
              }}
              onMouseLeave={(e) => {
                e.currentTarget
                  .querySelector(".dropdown-menu")
                  .classList.remove("show");
              }}
            >
              <Link
                className="nav-link dropdown-toggle vcg-nav-hover text-dark fw-semibold px-3 py-2"
                to="#"
                role="button"
                data-bs-toggle="dropdown"
              >
                Membership
              </Link>

              <ul className="dropdown-menu shadow-sm border-0">
                <li>
                  <Link
                    className="dropdown-item vcg-nav-hover py-2 fw-semibold "
                    to="/membership/register"
                  >
                    Get Membership
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item vcg-nav-hover py-2 fw-semibold "
                    to="/membership/track-request"
                  >
                    Track Membership Request
                  </Link>
                </li>
              </ul>
            </li>
            {/* <li className="nav-item">
              <Link
                className="nav-link vcg-nav-hover text-dark fw-semibold px-3 py-2"
                to="/exco-portal"
              >
                ExCo Portal
              </Link>
            </li> */}

            <li className="nav-item">
              <Link
                className="nav-link vcg-nav-hover text-dark fw-semibold px-3 py-2"
                to="/contact"
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}
